console.log('✅ custom-ajaxinate.js loaded');

function updateVariantCountInfo() {
  const visible = document.querySelectorAll('.product-box').length;
  const countDiv = document.getElementById('variant-counts');

  if (countDiv) {
    var total = countDiv.dataset.total || visible;
    if(visible>total){
      total = visible;
    }
    const infoText = `Showing ${visible} of ${total} variants`;
    const target = document.getElementById('ProductCountDesktop');
    if (target) {
      target.textContent = infoText;
      console.log('✅ Updated variant count:', infoText);
    }
  }

  // Re-initialize custom JS
  const wishlistEvent = new CustomEvent("initialize:wishlist-button");
  document.dispatchEvent(wishlistEvent);

  if (typeof window.initVariantChanger === 'function') {
    window.initVariantChanger(document.getElementById('main-collection-product-grid'));
  }

  if (typeof window.initSwatchOptionImage === 'function') {
    window.initSwatchOptionImage();
  }
}

// Setup a MutationObserver to watch for product grid changes
document.addEventListener('DOMContentLoaded', function () {
  const grid = document.getElementById('main-collection-product-grid');
  console.warn(' CollectionProductGrid  found');
  if (!grid) {
    console.warn('⚠️ CollectionProductGrid not found');
    return;
  }

  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.addedNodes.length > 0) {
        console.log('🟢 New product(s) added via Load More');
        updateVariantCountInfo();
        break;
      }
    }
  });

  observer.observe(grid, {
    childList: true,
    subtree: true,
  });

  console.log('👀 MutationObserver attached to CollectionProductGrid');
});
